import React, { useEffect, useState } from "react";
import '../css/epk.css';
const MasterSongList = () => {
    const [masterSongs, setMasterSongs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_BASE_URL = ""; // same-origin so the login cookie is sent

    useEffect(() => {
        const fetchSongs = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/songlist`);
                const data = await res.json();
                setMasterSongs(data);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setError("Failed to load songs.");
                setLoading(false);
            }
        };

        fetchSongs();
    }, [API_BASE_URL]);

    if (loading) return <p>Loading songs...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="song-list">
            <h3>Sample of our Song List</h3>
            <div>
                {masterSongs.map((song, index) => (
                    <p key={index}>
                        {song.songTitle} — {song.artist}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default MasterSongList;
